import api from '@/lib/api';
import type { AlertListResponse, AlertsQuery, SubscriptionAlert } from '@/types/admin';

function unwrap<T>(data: T | { data: T }): T {
  return (data as { data?: T }).data ?? (data as T);
}

export async function fetchAlerts(query: AlertsQuery = {}): Promise<AlertListResponse> {
  const params: Record<string, string | number | boolean> = {};
  if (query.unread) params.unread = true;
  if (query.type) params.type = query.type;
  if (query.severity) params.severity = query.severity;
  if (query.from) params.from = query.from;
  if (query.to) params.to = query.to;
  if (query.page) params.page = query.page;
  if (query.perPage) params.perPage = query.perPage;

  const { data } = await api.get('/admin/alerts', { params });
  const payload = unwrap<AlertListResponse>(data);
  return {
    items: payload.items ?? [],
    total: payload.total ?? 0,
    page: payload.page ?? 1,
    perPage: payload.perPage ?? 25,
  };
}

export async function fetchUnreadAlertCount(): Promise<number> {
  const { data } = await api.get('/admin/alerts/unread-count');
  const payload = unwrap<{ count: number }>(data);
  return payload?.count ?? 0;
}

export async function markAlertRead(id: string): Promise<SubscriptionAlert> {
  const { data } = await api.post(`/admin/alerts/${id}/read`);
  return unwrap<SubscriptionAlert>(data);
}

export async function markAllAlertsRead(): Promise<number> {
  const { data } = await api.post('/admin/alerts/read-all');
  const payload = unwrap<{ updated: number }>(data);
  return payload?.updated ?? 0;
}
